/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import axios from "axios";
import React, {useEffect, useState} from "react";
import HotButton from "../../../components/Common/HotButton";

import {
  GET_INVOICE_DETAIL,
  GetRequest,
  GetResultObject,
} from "../../../utils/API";
import { InvoicePrintGraphed } from "./components/InvoicePrint/InvoicePrintGraphed";

const InvoiceGenerate = (props) => {
  const [isPrinting, setIsPrinting] = useState()
  const [printProps, setPrintProps] = useState()


  useEffect(()=>{

    let invoiceId = document.location.href.split("invoiceId=")[1]
    
    axios.get(`${GET_INVOICE_DETAIL}`, {
      headers: {}, params: { invoiceId: invoiceId },
    }).then(result=>{
      GetResultObject(result, 'data', 200, data => {
        setPrintProps(data)
        setIsPrinting(true)
      })
    });
  }, [])



  return(
    <>
    {!isPrinting && (
      <label>Loading</label>
    )}
      {
        (isPrinting === true) && (
          <>
            <InvoicePrintGraphed
              printProps={printProps}
              conClose={()=>{setIsPrinting(false)}}
            />
          </>
        )
      }
    </>
  )

}
export default InvoiceGenerate
